import { element } from './util';

export const isEditorTypeAhead = (target: EventTarget | null): boolean => {
  const parentElement = (target as HTMLElement)?.parentElement;
  return !!element(parentElement)?.closest('.fabric-editor-typeahead');
};
